//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 48px;
    gap: 25px;
`;
export const Title = styled.h2`
    font-size: 20px;
    color: var(--dark-4);
    font-weight: 900;
    margin: 0;
    margin-bottom: 10px;
`;
export const Student = styled.h3`
    background-color: var(--light-blue-2);
    border-radius: 8px;
    padding: 25px 30px;
    font-size: 18px;
    font-weight: bold;
    width: 100%;
    margin: 0;
`;
export const Description = styled.p`
    margin: 0;
    margin-top: 8px;
    font-size: 14px;
    color: var(--light-gray-5);
`;
export const Adviser = styled.h4`
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
`;